import { rest } from 'msw';
import faker from 'faker';

faker.seed(7);

const appointments = [
    rest.get('/api/v2/appointments/appointments/:year/:grouping', (req, res, ctx) => {
		let { year, grouping } = req.params;
		grouping = decodeURIComponent(grouping);
        year = parseInt(year);

        const data = appointmentsByGrouping[grouping] || { count: 0, data: [], errors: [] };
        const content = {
            status: 200,
            data: {
                ...data,
                data: data.data.map(appointment => ({
                    ...appointment,
                    qualificationYear: year,
                }))
            }
        };
		return res(ctx.json(content));

    })
];

export default appointments;

const appointmentsByGrouping = {
    'Appointment Group': {
        "count": 7,
        "data": [
            {
                "appointmentId": 991198,
                "qualificationYear": 2019,
                "contractGrouping": "Appointment Group",
                "type": "PA",
                "description": "Principal Assessor",
                "appointee": {
                    "appointeeId": 181,
                    "name": faker.name.findName(),
                    "ni": faker.helpers.replaceSymbols('??######?')
                },
                "contract": {}
            },
            {
                "appointmentId": 1297832,
                "qualificationYear": 2019,
                "contractGrouping": "Appointment Group",
                "type": "PA",
                "description": "Principal Assessor",
                "team": "Health and Food Technology Advanced Higher",
                "code": "52011616",
                "appointee": {
                    "appointeeId": 23,
                    "name": faker.name.findName(),
                    "ni": faker.helpers.replaceSymbols('??######?')
                },
                "contract": {}
            },
            {
                "appointmentId": 1297830,
                "qualificationYear": 2019,
                "contractGrouping": "Appointment Group",
                "type": "MSL",
                "description": "Senior Team Leader",
                "team": "Health and Food Technology Advanced Higher",
                "code": "52011616",
                "appointee": {
                    "appointeeId": 19,
                    "name": faker.name.findName(),
                    "ni": faker.helpers.replaceSymbols('??######?')
                },
                "contract": {}
            },
            {
                "appointmentId": 1295722,
                "qualificationYear": 2019,
                "contractGrouping": "Appointment Group",
                "type": "QPV",
                "description": "Principal Verifier",
                "appointee": {
                    "appointeeId": 139920,
                    "name": faker.name.findName(),
                    "ni": faker.helpers.replaceSymbols('??######?')
                },
                "contract": {}
            },
            {
                "appointmentId": 95905222,
                "qualificationYear": 2019,
                "contractGrouping": "Appointment Group",
                "type": "QPV",
                "description": "Principal Verifier",
                "appointee": {
                    "appointeeId": 932,
                    "name": faker.name.findName(),
                    "ni": faker.helpers.replaceSymbols('??######?')
                },
                "contract": {}
            },
            {
                "appointmentId": 1293072,
                "qualificationYear": 2019,
                "contractGrouping": "Appointment Group",
                "type": "VE",
                "description": "Visiting Examiner",
                "team": "Music Advanced Higher",
                "code": "08040102",
                "appointee": {
                    "appointeeId": 181,
                    "name": faker.name.findName(),
                    "ni": faker.helpers.replaceSymbols('??######?')
                },
                "contract": {}
            },
            {
                "appointmentId": 991214,
                "qualificationYear": 2019,
                "contractGrouping": "Appointment Group",
                "type": "VA",
                "description": "PBNC Visiting Assessor",
                "appointee": {
                    "appointeeId": 14,
                    "name": faker.name.findName(),
                    "ni": faker.helpers.replaceSymbols('??######?')
                },
                "contract": {}
            }
        ],
        "errors": []
    }
}